import React, { useCallback, useMemo, useState } from 'react';

import Text from '@fmbt/ui/Text';

import Modal from './Modal';

type Notice = {
  description: string;
  title: string;
};

export function useNoticeModal() {
  const [notice, setNotice] = useState<Notice | null>(null);

  const dismissNotice = useCallback(() => {
    setNotice(null);
  }, []);

  const showNotice = useCallback((title: string, description: string) => {
    setNotice({ title, description });
  }, []);

  const noticeModal = useMemo(() => {
    if (!notice) {
      return null;
    }
    return (
      <Modal
        confirmText="OK"
        hideDismissButton
        isOpen
        maskClosable
        onConfirm={dismissNotice}
        onDismiss={dismissNotice}
        title={notice.title}
      >
        <Text v="body">{notice.description}</Text>
      </Modal>
    );
  }, [dismissNotice, notice]);

  return { noticeModal, showNotice };
}
